<template>
    <div class="about">


      <div style="position: relative;font-size: 0;">


        <div style="position: absolute;z-index: 99;color: #ffffff;font-size: 24px;top:  16px;left: 16px;" @click="goService">
          <van-icon name="arrow-left" />
        </div>

        <img src="../assets/images/m_r.png" style="width: 100%;"/>

        <div style="position: absolute;left: 0; right: 0;top: 35%;">
          <div style="margin: 0 auto;min-height: 40px;text-align: left;padding-left: 16px;">
            <div style="font-size: 18px;color: #ffffff;font-weight: bold;">{{service.tit}}</div>

            <div style="font-size: 16px;color: #ffffff;font-weight: bold;margin-top: 20px;"><span style="font-size: 14px;">￥</span>{{service.money1}}</div>

            <div style="margin-top: 12px;"> <van-button type="primary" style="position: relative;border-radius: 8px;">
              扫我咨询

              <img src="../assets/images/server_contact.png" style="position: absolute;left: 115px;top: -50px;width: 100px;"/>
            </van-button></div>
          </div>
        </div>
      </div>

      <div style="padding: 16px;">
        <div class="service-content" v-html="service.txt">

        </div>

        <div style="height: 80px"></div>
      </div>
    </div>
</template>

<style>

    .service-content img
    {
      width: 100%;
    }

    .service-block
    {
        padding: 16px;
    }

    .time-text
    {
        font-size: 0.4rem;
        color:#000000;
    }

    .price-text
    {
        font-size: 0.7rem;
        color:#000000;
    }

    .desc-text
    {
        font-size: .45rem;
        color: #222222;
        line-height: .675rem;
    }

    .service-item
    {
        background-color: #ffffff;
        border-radius: 8px;
        padding: 16px;
        position: relative;
        min-height: 70px;
        margin-top: 12px;
    }

    .service-item:after{
        content: "立即办理";
        font-size: 12px;
        background-color: #da4725;
        color:#ffffff;
        line-height: 40px;
        height: 40px;
        border-top-left-radius: 40px;
        border-bottom-left-radius: 40px;
        text-align: center;
        width: 100px;
        display: block;
        right: 0;
        top: 40px;
        position: absolute;
    }

    .service-title{
        font-size: 14px !important;
        line-height: 24px;
        color: #5f5ea9;
        font-weight: bold;
        text-align: left;
    }

    .service-price
    {
        font-size: 16px !important;
        line-height: 24px;
        color: #f15422;
        font-weight: 500;
        text-align: right;
    }

    .service-p{
        padding-left: 16px;
        position: relative;
        font-size: 12px;
        color: #989898;
        line-height: 18px;
        text-align: left;
        margin-top: 8px;
        padding-right: 85px;
    }

    .service-p:before
    {
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 100%;
        background: #5f5ea9;
        display: block;
        left: 4px;
        top: 6px;
        position: absolute;
    }

</style>
<script>
    import common from '../assets/js/common'
    import addone from '../components/addone'
    import _ from 'underscore'

    export default {
        name: 'HelloWorld',
        props: {
            msg: String
        },
        components:
            {
                addone
            },
        data: function(){
            return {
                list_combine:[],
                active:0,
                service:{}
            }
        },
        methods:{
            initPage:function()
            {
                common.cusHttp(this,'/boot/service.php?id='+this.id+'&action=detail',{id:1}).then((res)=>{
                    res = JSON.parse(res.data)
                    if( res.status == 1 ) {
                        this.service = res.data;
                        console.log(this.service.txt)
                    }
                })
            },
            goDetail(item)
            {
                this.$router.push({ path: '/service_detail', query: { id: item }})
            },
            goService()
            {
                this.$router.push({ path: '/service'})
            }
        },
        created:function()
        {
            /**
             * 如果没有token则跳到登录页哟
             */
            common.setTitle('确认信息');
            this.id = common.getUrlParam('id');
        },
        mounted()
        {
            this.$store.commit('setTarbarIndex',1)
            this.initPage();
        },
        onShow()
        {
        },
        computed:{
        }
    }
</script>